import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Checkbox,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';

import { All } from './FilterColumn';
import type { FilterListItemProps } from './FilterListItem';

interface AllCheckboxProps<T>
  extends Omit<FilterListItemProps<T>, 'filterItem'> {}

const AllCheckbox = <FilterOptionType extends string>({
  selectedFilters,
  setSelectedFilters,
  allFilterValues,
}: AllCheckboxProps<FilterOptionType>) => {
  const { t } = useTranslation('followUp');
  const label = t('all');
  const value = All;
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    setChecked(selectedFilters.length === allFilterValues.length);
  }, [allFilterValues.length]);
  const indeterminate =
    checked && selectedFilters.length < allFilterValues.length;

  const handleClick = () => {
    setSelectedFilters(() => {
      if (indeterminate || !checked) {
        return allFilterValues;
      }
      return [];
    });
    setChecked((prev) => !prev);
  };
  return (
    <ListItemButton
      role="listitem"
      onClick={handleClick}
      sx={(theme) => ({ height: theme.spacing(4.5) })}
    >
      <ListItemIcon>
        <Checkbox
          indeterminate={indeterminate}
          checked={checked && !indeterminate}
          tabIndex={-1}
          disableRipple
          inputProps={{
            'aria-labelledby': `${value}-label`,
          }}
          size="small"
        />
      </ListItemIcon>
      <ListItemText
        id={`${value}-label`}
        primary={<Typography variant="body4">{label}</Typography>}
      />
    </ListItemButton>
  );
};

export default AllCheckbox;
